
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/layout/hex-text.kpa`,
      template: `<article class="hex-text{{reverse}}" aria-labelledby="{{label}}">
        <div>
            {{svg}}

            <div class="hexagon-image">
                <img src="{{image}}" alt="Bild von {{title}}">
            </div>

            {{svg}}
        </div>

        <div class="text-content">
            <h2 id="{{label}}">{{title}}</h2>
            <slot></slot>
        </div>
    </article>`,
      style: `hex-text .hex-text {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  height: auto;
}
hex-text .hex-text > div {
  position: relative;
  width: auto;
  height: 100%;
}
hex-text .hex-text > div svg {
  width: auto;
  height: 100%;
  min-width: 500px;
}
hex-text .hex-text > div svg:last-of-type {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  height: 100%;
  z-index: 2;
}
hex-text .hex-text > div .hexagon-image {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90%;
  height: 92%;
  transform: translate(-50%, -50%);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  z-index: 1;
}
hex-text .hex-text > div .hexagon-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(48, 69, 71, 0.02), rgba(48, 69, 71, 0.23));
  background-blend-mode: multiply;
}
hex-text .hex-text > div .hexagon-image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  filter: grayscale(100%);
  transform: scale(1);
  transition: transform 0.3s, filter 0.3s;
}
@media (max-width: 1000px) {
  hex-text .hex-text > div svg {
    min-width: 400px;
  }
}
@media (max-width: 800px) {
  hex-text .hex-text > div svg {
    min-width: 350px;
  }
}
hex-text .hex-text div.text-content {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
}
hex-text .hex-text div.text-content ul {
  padding: 0;
  margin: 0;
}
hex-text .hex-text div.text-content ul li {
  list-style-type: none;
}
hex-text .hex-text:hover .hexagon-image img {
  transform: scale(1.05);
  filter: grayscale(0);
}
@media (pointer: coarse) {
  hex-text .hex-text > div .hexagon-image img {
    transform: scale(1.05);
    filter: grayscale(0);
  }
}
hex-text .hex-text.reverse {
  flex-direction: row-reverse;
}
@media (max-width: 700px) {
  hex-text .hex-text {
    gap: 8px;
    flex-flow: column nowrap;
    height: auto;
  }
  hex-text .hex-text > div svg {
    min-width: 500px;
  }
  hex-text .hex-text.reverse {
    flex-direction: column;
  }
}
@media (max-width: 520px) {
  hex-text .hex-text > div svg {
    min-width: 300px;
  }
  hex-text .hex-text .text-content {
    padding-top: 12px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        label: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        image: {
            type: String,
            default: "",
        },
        left: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        reverse() {
            return this.right ? " reverse" : "";
        },
        svg() {
            return \`
                    <svg width="100%" height="100%" viewBox="0 0 600 680" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/2000/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
                        <g transform="matrix(1,0,0,1,-0.600136,41)">
                            <path 
                                d="M300.6,-1L560.754,149L560.754,449L300.6,599L40.446,449L40.446,149L300.6,-1Z" 
                                style="fill:none;stroke:rgb(100,193,108);stroke-width:36px;" 
                            />
                        </g>
                    </svg>
                \`;
        },
    },
};
 })()`
    };
  